'use client';

import { useErrorTracking } from '@/app/common/monitoring/aws';
import { useEffect } from 'react';

export function ErrorTracker() {
  const { trackError } = useErrorTracking();

  useEffect(() => {
    // Handle unhandled JavaScript errors
    const handleError = (event: ErrorEvent) => {
      trackError(event.error || new Error(event.message), {
        category: 'javascript',
        operation: 'unhandled_error',
        severity: 'high',
        metadata: {
          filename: event.filename,
          lineno: event.lineno,
          colno: event.colno,
        },
      });
    };

    // Handle unhandled promise rejections
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      trackError(event.reason instanceof Error ? event.reason : new Error(String(event.reason)), {
        category: 'promise',
        operation: 'unhandled_rejection',
        severity: 'high',
        metadata: {
          reason: event.reason,
        },
      });
    };

    // Add global error listeners
    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    // Cleanup listeners on unmount
    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, [trackError]);

  return null;
}
